const routes = {
    home: (token?: string) => (token ? `/${token}` : "/:token"),
    thankYouPage: () => "/:token/thankYouPage",
};

export default routes;
